import { DateTime } from 'luxon';
import type { ILine } from '../../../../models/line.model';
import MunicipalityApiModel from './municipality.api-model';
import type { TransportMode } from '../../../../models/transport-mode.enum';
import type { TransportSubMode } from '../../../../models/transport-sub-mode.enum';

export class LineApiModel {
  public static mapToBusinessModel(apiModel: LineApiModel): ILine {
    return {
      gid: apiModel.gid,
      technicalLineNumber: apiModel.technicalLineNumber,
      name: apiModel.name,
      shortName: apiModel.shortName,
      backgroundColor: apiModel.backgroundColor,
      foregroundColor: apiModel.foregroundColor,
      borderColor: apiModel.borderColor,
      directionName: apiModel.directionName,
      transportMode: apiModel.transportMode,
      transportSubMode: apiModel.transportSubMode,
      contractorId: apiModel.contractorId,
      isPublicTransport: apiModel.isPublicTransport,
      isWheelchairAccessible: apiModel.isWheelchairAccessible,
      municipalities: apiModel.municipalities?.map((m) => MunicipalityApiModel.mapToBusinessModel(m)),
      appliesFrom: DateTime.fromISO(apiModel.appliesFrom),
      appliesUpto: apiModel.appliesUpto ? DateTime.fromISO(apiModel.appliesUpto) : undefined,
      designation: apiModel.designation,
      transportAuthorityGid: apiModel.transportAuthorityGid,
    };
  }

  public gid: string | undefined;
  public technicalLineNumber!: string;
  public name!: string;
  public shortName!: string;
  public backgroundColor: string | undefined;
  public foregroundColor: string | undefined;
  public borderColor: string | undefined;
  public directionName: string | undefined;
  public transportMode!: TransportMode;
  public transportSubMode!: TransportSubMode;
  public contractorId!: number;
  public isPublicTransport: boolean | undefined;
  public isWheelchairAccessible: boolean | undefined;
  public municipalities!: MunicipalityApiModel[];
  public appliesFrom!: string;
  public appliesUpto: string | undefined;
  public designation: string | undefined;
  public transportAuthorityGid: string | undefined;
}
